<navbar-component></navbar-component>

<main class="img-background">
  <div style="display: flex; flex-direction: column; min-height: 80vh;">

    <div class="label-wrapper">
      <img class="label-img" src="assets/fotos/laundry-head.svg" />
    </div>

    <div class="container">
      <div class="information-container">
        <div class="information">
          <div class="information-title">
            O PROJETO:
          </div>
          <div class="information-subtitle">
            Projeto lavanderia têxtil: Beneficiando tecidos e reconstruindo resíduos
          </div>
          <div class="information-text">
            Aprovado no edital Funcultura 2017/2018, trabalha com fibrilas têxteis resultantes do atrito sofrido por peças de roupa nas secadoras de lavanderias de beneficiamento têxtil para sua transformação em nova matéria-prima com sua aplicação em produtos de design e moda.  Essa transformação acontece com os processos de molhagem, trituração, colagem, prensagem e secagem das fibrilas têxteis e seu aglutinador, formando uma massa.
          </div>
        </div>

        <div class="laundry-images">
          <img style="width: 100%;" src="assets/fotos/circulos-lavanderia.svg" />
        </div>
      </div>

      <div class="leavings-container">
        <button class="button" routerLink="/laundry-showcase" mat-button>
          <mat-icon class="result-img" svgIcon="result"></mat-icon>
        </button>
        <img style="width: 100%;" src="assets/fotos/laundry-bench.svg" />
      </div>
    </div>

  </div>
</main>

<footer-component></footer-component>
